<div class="form-group">
  <label for="prod-m">{{ 'form.language'| translate }}</label>
  <angular2-multiselect [data]="languagesList"
      [(ngModel)]="languageSelected"
      [settings]="multiselectSettings_base"
      (onSelect)="onLanguageSelect()">
  </angular2-multiselect>
</div>
